/*
  Marie Gems polish layer: scroll-progress bar, count-up stats, button
  sparkle-follows-cursor, subtle hero parallax. Additive only — doesn't
  touch scrub.js's own scroll handling. Transforms/opacity/width only,
  everything gated behind prefers-reduced-motion where it matters.
*/
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---------- hand-drawn swash under the last word of every page H1 ----------
  // Skips h1s that already build their own swash manually (hero-video.liquid).
  var SWASH_SVG = '<svg class="headline-swash" viewBox="0 0 340 24" preserveAspectRatio="none" aria-hidden="true"><path d="M4 14C60 6 120 4 170 10C220 16 280 18 336 8"/></svg>';
  document.querySelectorAll('h1').forEach(function (h1) {
    if (h1.querySelector('.headline-swash')) return; // already has one (hero)
    var text = h1.textContent.trim();
    if (!text) return;
    var words = text.split(/\s+/);
    var lastWord = words.pop();
    var rest = words.join(' ');
    h1.innerHTML = (rest ? rest + ' ' : '') + '<span class="swash-word">' + lastWord + SWASH_SVG + '</span>';
  });

  // ---------- scroll-progress bar ----------
  var bar = document.createElement('div');
  bar.className = 'scroll-progress';
  document.body.appendChild(bar);
  var barTicking = false;
  function updateBar() {
    var doc = document.documentElement;
    var max = doc.scrollHeight - doc.clientHeight;
    var pct = max > 0 ? (doc.scrollTop / max) * 100 : 0;
    bar.style.width = pct + '%';
    barTicking = false;
  }
  window.addEventListener('scroll', function () {
    if (barTicking) return;
    barTicking = true;
    requestAnimationFrame(updateBar);
  }, { passive: true });
  updateBar();

  // ---------- count-up on stat numbers ----------
  function animateCount(el, target, suffix, prefix, decimals) {
    var start = 0;
    var duration = 1100;
    var startTime = null;
    function step(ts) {
      if (!startTime) startTime = ts;
      var progress = Math.min(1, (ts - startTime) / duration);
      var eased = 1 - Math.pow(1 - progress, 3);
      var value = start + (target - start) * eased;
      el.textContent = prefix + value.toFixed(decimals) + suffix;
      if (progress < 1) requestAnimationFrame(step);
      else el.textContent = prefix + target.toFixed(decimals) + suffix;
    }
    requestAnimationFrame(step);
  }

  var countEls = document.querySelectorAll('.fact-value, .about-facts .v');
  if (countEls.length && 'IntersectionObserver' in window) {
    var countIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        countIo.unobserve(entry.target);
        var el = entry.target;
        var text = el.textContent;
        var match = text.match(/^([^\d]*)([\d,]+(?:\.\d+)?)(.*)$/);
        if (!match || reduceMotion) return;
        var prefix = match[1];
        var numStr = match[2].replace(/,/g, '');
        var suffix = match[3];
        var decimals = numStr.indexOf('.') > -1 ? numStr.split('.')[1].length : 0;
        var target = parseFloat(numStr);
        if (isNaN(target)) return;
        animateCount(el, target, suffix, prefix, decimals);
      });
    }, { threshold: 0.6 });
    countEls.forEach(function (el) { countIo.observe(el); });
  }

  // ---------- button sparkle follows cursor ----------
  document.querySelectorAll('.btn').forEach(function (btn) {
    btn.addEventListener('pointermove', function (e) {
      var rect = btn.getBoundingClientRect();
      btn.style.setProperty('--spark-x', ((e.clientX - rect.left) / rect.width * 100) + '%');
      btn.style.setProperty('--spark-y', ((e.clientY - rect.top) / rect.height * 100) + '%');
    });
  });

  // ---------- subtle hero parallax (copy drifts slower than scroll) ----------
  if (!reduceMotion) {
    var copyEls = document.querySelectorAll('.scrub-copy');
    if (copyEls.length) {
      var parallaxTicking = false;
      function updateParallax() {
        copyEls.forEach(function (copy) {
          var sticky = copy.closest('.scrub-sticky');
          if (!sticky) return;
          var rect = sticky.getBoundingClientRect();
          var progress = 1 - Math.max(0, Math.min(1, rect.top / (window.innerHeight || 1)));
          var shift = Math.min(24, progress * 24);
          copy.style.transform = 'translate3d(0,' + shift + 'px,0)';
        });
        parallaxTicking = false;
      }
      window.addEventListener('scroll', function () {
        if (parallaxTicking) return;
        parallaxTicking = true;
        requestAnimationFrame(updateParallax);
      }, { passive: true });
      updateParallax();
    }
  }
})();
